module.exports = __webpack_public_path__ + "img/bus-warbe-rfms.fb71149b.png";